'use strict';

/**
 * Builds one discount row by cloning the always-present hidden template (keeps the
 * promo-icon / checkmark static URLs correct).
 * @param {Object} $scope - jQuery scope (modal or page)
 * @param {string} message - text to display
 * @param {boolean} isSuccess - show the green checkmark instead of the promo tag icon
 * @returns {Object} jQuery row element
 */
function buildRow($scope, message, isSuccess) {
    var $row = $scope.find('.approaching-discount-template .single-approaching-discount').first().clone();
    $row.find('.promo-callout-label').text(message);
    $row.find('.promo-discount-icon').toggleClass('d-none', isSuccess);
    $row.find('.mini-cart-green-checkmark-container').toggleClass('d-none', !isSuccess);
    return $row;
}

/**
 * Reads the promo callouts currently rendered in the given scope.
 * @param {Object} $scope - jQuery scope (modal or page)
 * @returns {string[]} callout messages
 */
function readCallouts($scope) {
    return $scope.find('.approaching-discounts .single-approaching-discount').map(function () {
        return $(this).attr('data-callout-msg') || '';
    }).get();
}

/**
 * Seeds tracking from the server-rendered DOM.
 * @param {Object} $page - jQuery page scope
 * @returns {Object} tracking state
 */
function init($page) {
    return {
        callouts: readCallouts($page),
        unlocked: []
    };
}

/**
 * Re-renders the approaching discounts, turning any promo that just dropped off the list into an
 * "unlocked" success row. State is mutated in place.
 * @param {Object} $page - jQuery page scope
 * @param {Object} approachingDiscountObj - tracking state from init()
 * @param {Array} discounts - updated approaching discounts for the cart
 * @param {boolean} isRemoval - true when the update came from removing a line item
 */
function render($page, approachingDiscountObj, discounts, isRemoval) {
    var $container = $page.find('.approaching-discounts');
    if (!$container.length) {
        return;
    }

    var list = discounts || [];
    var callouts = list.map(function (item) { return item.calloutMsg || ''; });

    if (isRemoval || callouts.length > approachingDiscountObj.callouts.length) {
        // Item removed, or a promo came back into reach: clear the success messages.
        approachingDiscountObj.unlocked = [];
    } else {
        // Any promo that dropped off the approaching list was just unlocked.
        approachingDiscountObj.callouts.forEach(function (callout) {
            if (callouts.indexOf(callout) === -1) {
                approachingDiscountObj.unlocked.push(callout);
            }
        });
    }

    $container.empty();
    var template = $container.attr('data-qualified-msg') || '';
    approachingDiscountObj.unlocked.forEach(function (callout) {
        $container.append(buildRow($page, template.replace('{0}', callout), true));
    });
    list.forEach(function (item) {
        $container.append(buildRow($page, item.discountMsg, false));
    });

    $page.find('.minicart-approaching-discounts')
        .toggleClass('d-none', approachingDiscountObj.unlocked.length === 0 && list.length === 0);

    approachingDiscountObj.callouts = callouts;
}

module.exports = {
    init: init,
    render: render
};
